/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { Component } from 'react';
import { object, node } from 'prop-types';
import { withRouter } from 'react-router-dom';

import track from 'utils/track';

/**
 * This is the TrackPageView component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class TrackPageView extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {Object}
   */
  static propTypes = {
    location: object.isRequired,
    children: node.isRequired,
  };

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    const { location: newLocation } = prevProps;

    if (location !== newLocation) {
      track('page', location.pathname);
    }
  }

  /**
   * Render TrackPageView.
   *
   * @return {JSX}
   */
  render() {
    const { children } = this.props;

    return children && children;
  }
}

export default withRouter(TrackPageView);
